import { Line } from "vue-chartjs";
import chartMixin from "./chartMixin";

export default {
  mixins: [Line, chartMixin],
};
